var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.25V18.25C18 18.4489 17.921 18.6397 17.7803 18.7803C17.6397 18.921 17.4489 19 17.25 19H12C11.8011 19 11.6103 18.921 11.4697 18.7803C11.329 18.6397 11.25 18.4489 11.25 18.25V13.375C11.25 13.2755 11.2105 13.1802 11.1402 13.1098C11.0698 13.0395 10.9745 13 10.875 13H7.125C7.02554 13 6.93016 13.0395 6.85983 13.1098C6.78951 13.1802 6.75 13.2755 6.75 13.375V18.25C6.75 18.4489 6.67098 18.6397 6.53033 18.7803C6.38968 18.921 6.19891 19 6 19H0.75C0.551088 19 0.360322 18.921 0.21967 18.7803C0.0790178 18.6397 0 18.4489 0 18.25V9.25C0.000184396 8.85225 0.15834 8.47085 0.439687 8.18969L7.93969 0.689687C8.22096 0.408595 8.60235 0.250694 9 0.250694C9.39765 0.250694 9.77904 0.408595 10.0603 0.689687L17.5603 8.18969C17.8417 8.47085 17.9998 8.85225 18 9.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.772132794141ffda5d3107739b1e735a.svg";
export { ForwardRef as ReactComponent };